/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react"

interface CustomProgressProps {
  value: number // 0-100
  className?: string
}

export function CustomProgress({ value, className = "" }: CustomProgressProps) {
  const clampedValue = Math.min(100, Math.max(0, value))

  return (
    <div className={`relative w-full h-3 bg-gray-200 rounded-full overflow-hidden ${className}`}>
      {/* Background */}
      <div className='absolute inset-0 bg-gray-200 rounded-full' />

      {/* Progress Fill */}
      <div
        className='absolute top-0 left-0 h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full transition-all duration-300 ease-out'
        style={{ width: `${clampedValue}%` }}
      />

      {/* Shine Effect for Active Progress */}
      {value > 0 && value < 100 && (
        <div
          className='absolute top-0 h-full w-8 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-pulse rounded-full'
          style={{ left: `${Math.max(0, clampedValue - 8)}%` }}
        />
      )}

      {/* Percentage Text Overlay */}
      <div className='absolute inset-0 flex items-center justify-center'>
        <span className='text-xs font-medium text-white drop-shadow-sm'>{clampedValue}%</span>
      </div>
    </div>
  )
}
